import { theme } from '~/theme';
import { cssColorHexToRgbA } from '~/utils/helper';

export const useSxStyles = () => {
  const fadeColor = '#e0e0e0';

  const backgroundFade = `linear-gradient(270deg, ${cssColorHexToRgbA(
    fadeColor,
    0.06,
  )}, ${cssColorHexToRgbA(fadeColor, 0)} 15%, ${cssColorHexToRgbA(
    fadeColor,
    0,
  )} 70%, ${cssColorHexToRgbA(fadeColor, 0.08)})`;

  return {
    root: {
      border: `solid 1px ${theme.palette.divider}`,
      backgroundImage: backgroundFade,
      paddingTop: theme.spacing(2),
    },
    approveStep: { display: 'flex', justifyContent: 'center' },
    ultimateApproval: { backgroundColor: 'rgba(0,0,0,0.05)', paddingTop: 1 },
    ultimateApprovalInfo: {
      padding: theme.spacing(0, 1, 1, 1),
    },
  };
};
